export const TENANT_DOCUMENT_NAVIGATION_EVENT = "tenant-document-navigation";

const addValueIdentifiers = (identifiers, value) => {
  if (value && typeof value === "object") {
    const nestedValue = value.$oid ?? value._id ?? value.id ?? value.file_name;
    if (nestedValue !== undefined) {
      addValueIdentifiers(identifiers, nestedValue);
    } else if (typeof value.toString === "function") {
      const stringValue = value.toString();
      if (stringValue !== "[object Object]") {
        addValueIdentifiers(identifiers, stringValue);
      }
    }
    return;
  }

  if (value === null || value === undefined || value === "") return;

  const normalized = String(value).trim().toLowerCase();
  if (!normalized) return;
  identifiers.add(normalized);

  const withoutQuery = normalized.split(/[?#]/)[0];
  if (withoutQuery) identifiers.add(withoutQuery);

  try {
    const pathname = new URL(normalized).pathname;
    if (pathname) {
      const decodedPath = decodeURIComponent(pathname).toLowerCase();
      identifiers.add(decodedPath);
      const fileName = decodedPath.split("/").filter(Boolean).pop();
      if (fileName) identifiers.add(fileName);
    }
  } catch (error) {
    const decodedPath = (() => {
      try {
        return decodeURIComponent(withoutQuery);
      } catch (decodeError) {
        return withoutQuery;
      }
    })();
    const fileName = decodedPath.split("/").filter(Boolean).pop();
    if (fileName) identifiers.add(fileName.toLowerCase());
  }
};

export const getTenantDocumentIdentifiers = (document) => {
  const identifiers = new Set();
  [
    document?.tenant_doc_id,
    document?._id,
    document?.id,
    document?.document_id,
    document?.file_name,
    document?.filename,
    document?.url,
    document?.metadata?.originalname,
  ].forEach((value) => addValueIdentifiers(identifiers, value));

  return [...identifiers];
};

export const getServiceFileDocumentIdentifiers = (serviceFile) => {
  const identifiers = new Set();
  [
    serviceFile?.tenant_doc_id,
    serviceFile?.file_name,
    serviceFile?.filename,
    serviceFile?.url,
    serviceFile?.metadata?.originalname,
  ].forEach((value) => addValueIdentifiers(identifiers, value));

  return [...identifiers];
};

export const documentMatchesIdentifiers = (document, identifiers = []) => {
  const documentIdentifiers = new Set(getTenantDocumentIdentifiers(document));
  return identifiers.some((identifier) => documentIdentifiers.has(identifier));
};

export const navigateToTenantDocument = ({
  tenantId,
  isGuarantor = false,
  service = null,
  serviceFile,
}) => {
  if (typeof window === "undefined" || !serviceFile) return;

  window.dispatchEvent(
    new CustomEvent(TENANT_DOCUMENT_NAVIGATION_EVENT, {
      detail: {
        tenantId: String(tenantId ?? ""),
        isGuarantor: isGuarantor === true,
        service: String(service ?? serviceFile?.service ?? "")
          .toUpperCase()
          .trim(),
        identifiers: getServiceFileDocumentIdentifiers(serviceFile),
      },
    })
  );
};
